import axios from "axios";
import {
  openSupportConversationUrl,
  getMySupportConversationsUrl,
  getSupportMessagesUrl,
  sendSupportMessageUrl,
  markSupportReadUrl,
} from "../utils/urls";

// Open (or reuse) the advisor's active support conversation.
export const openSupportConversation = async (subject) => {
  const res = await axios.post(openSupportConversationUrl, { subject });
  return res?.data?.data;
};

export const getMySupportConversations = async () => {
  const res = await axios.get(getMySupportConversationsUrl);
  return res?.data?.data;
};

export const getSupportMessages = async (conversationId, params = {}) => {
  const res = await axios.get(getSupportMessagesUrl(conversationId), { params });
  return res?.data?.data;
};

// body/text optional, file optional (File object). Sent as multipart.
export const sendSupportMessage = async ({ conversationId, body, file }) => {
  const formData = new FormData();
  formData.append("conversation_id", conversationId);
  if (body) formData.append("body", body);
  if (file) formData.append("attachment", file);
  const res = await axios.post(sendSupportMessageUrl, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res?.data?.data;
};

export const markSupportRead = async (conversationId) => {
  const res = await axios.patch(markSupportReadUrl(conversationId));
  return res?.data?.data;
};
